export interface DarioSystemData {
	imageUrl?: string
	firstName?: string
	lastName?: string
	birthDate?: number | null
	gender?: DarioSystemGender
	height?: number | null
	weight?: number | null
	language?: string
	units?: DarioSystemDataUnits
	phone?: string
	region?: string
	weightTarget?: number
	provisioningId?: string
	additionalOptions?: DarioSystemDataAdditionalOptions
	diabetesType?: string
	diabetesDiagnosed?: number | null
	hba1c?: DarioSystemReportedA1C
	insulinTreatment?: string
	insulin?: {
		bolus: string | null
		basal: string | null
	}
	targetRanges?: DarioSystemBGTargetRanges
}

export enum DARIO_SYSTEM_DATA_ACTION_TYPES {
	DARIO_SYSTEM_SET_DATA = 'DARIO_SYSTEM_SET_DATA',
	DARIO_SYSTEM_DATA_PARTIALLY_UPDATE = 'DARIO_SYSTEM_DATA_PARTIALLY_UPDATE',
}

interface DarioSystemDataUnits {
	general: string
	glucose: string
	food: {
		units: string
		customMultiplier: number
	}
}

interface DarioSystemDataAdditionalOptions {
	smoking?: string
	['daily_activity']?: number | null
	['stress_level']?: number | null
	['alcohol_consumption']?: number | null
	comorbidities?: Array<string>
	medications?: Array<string>
	ethnicity?: Array<string>
	['family_genetics']?: string
	challenges?: {
		[key: string]: string
	}
	['oral_medications']?: Array<string>
	['property_date_diagnosed_with_ht']?: number
	['property_diagnosed_with_ht']?: string
	['property_ht_medications']?: string
	['property_ht_medications_meds_list']?: Array<string>
	['property_ht_last_test_results']?: DarioSystemHtLastTestResults
}

export interface DarioSystemReportedA1C {
	value: number | null
	date: number | null
}

export interface DarioSystemBGTargetRanges {
	[key: string]: Array<number> | number
	fasting: Array<number>
	general: Array<number>
	preMeal: Array<number>
	postMeal: Array<number>
	bedtime: Array<number>
	hyper: number
	hypo: number
}

export interface DarioSystemHtLastTestResults {
	systolic: number
	diastolic: number
	monthsAgo: number
	pulse: number
}

export type DarioSystemGender = 'male' | 'female' | 'other' | string

interface DarioSystemSetDataAction {
	type: DARIO_SYSTEM_DATA_ACTION_TYPES.DARIO_SYSTEM_SET_DATA
	payload: DarioSystemData
}

interface DarioSystemPartiallyUpdateAction {
	type: DARIO_SYSTEM_DATA_ACTION_TYPES.DARIO_SYSTEM_DATA_PARTIALLY_UPDATE
	payload: DarioSystemData
}

export type DarioSystemActions =
	| DarioSystemSetDataAction
	| DarioSystemPartiallyUpdateAction
